import { useCallback, useEffect, useMemo } from 'react';
import SgSessionStorageService from 'sg-session-storage';
import _ from 'lodash';

function useSgCepFlowPageReload(pathname) {
    const currentFlowStep = useMemo(() => {
        return pathname.split('/')[2];
    }, [pathname]);

    const shouldGoToHomePageOnRefresh = useMemo(() => {
        return {
            // MTA-specific
            entry: false,
            vehicle: true,
            driver: true,
            coverages: true,
            quote: true,
            // Renewal-specific
            summary: false,
            renewalchanges: true,
            renewaladdons: true,
            renewalQuote: true,
            // Common
            declarations: true,
            payment: true,
            confirmation: true
        };
    }, []);

    const onunload = useCallback(() => {
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.FORCE_CEP_REFRESH_TO_HOME_PAGE, true);
    }, []);

    const onbeforeunload = useCallback((event) => {
        // Returning non-empty string with event.returnValue or function return is required by some browsers to show the confirmation dialog
        const dummyReturn = '_';
        _.set(event, 'returnValue', dummyReturn);
        return dummyReturn;
    }, []);

    useEffect(() => {
        if (shouldGoToHomePageOnRefresh[currentFlowStep]) {
            if (currentFlowStep !== 'confirmation') {
                window.addEventListener('beforeunload', onbeforeunload);
            }
            window.addEventListener('unload', onunload);
            return () => {
                window.removeEventListener('beforeunload', onbeforeunload);
                window.removeEventListener('unload', onunload);
            };
        }
        return () => {
        };
    }, [currentFlowStep, onbeforeunload, onunload, shouldGoToHomePageOnRefresh]);
}

export default useSgCepFlowPageReload;
